module.exports = __webpack_public_path__ + "img/recruitment.235d8956.png";